import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import "../src/fonts.css";
import "flag-icons/css/flag-icons.min.css";
import SpeakersCarousel from './components/SpeakersCarousel';
import Why from './components/Why';
import Agenda from './components/Agenda';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import Auspiciadores from './components/Auspiciadores';


function App() {
  return (
    <>
      <div className="App">
        <Hero />
        <About />
        <SpeakersCarousel />
        <Why />
        <Agenda />
        <Testimonials />
        <Footer />
        <Auspiciadores />
      </div>
    </>
  );
}

export default App;
